import React, { useState } from 'react';
import { Eye, EyeOff, ChevronDown, ChevronRight } from 'lucide-react';
import { useLayerStore } from '../../store/useLayerStore';

// Mock store for demo purposes

const LayerControl = () => {
  const [expandedSections, setExpandedSections] = useState({});
  const { visibleLayers, toggleLayer } = useLayerStore();
  const [collapsed, setCollapsed] = useState(false);
  
  const layerData = [
    { id: 'flurstucke', name: 'Flurstücke', color: '#95999D', hasChildren: false },
    { 
      id: 'nutzung', 
      name: 'Nutzung', 
      color: '#fcfcfcff', 
      hasChildren: true,
      subLayers: [
        { id: 'infrastruktur_verkehr', name: 'Infrastruktur und Verkehr', color: '#efcc97' },
        { id: 'bauwerke_anlagen', name: 'Bauwerke und Anlagen', color: '#bca9d0' },
        { id: 'gewaesser', name: 'Gewässer', color: '#91bed3' },
        { id: 'naturraeume_vegetation', name: 'Naturräume und Vegetation', color: '#c5cc9e' },
        { id: 'rohstoff_bergbau', name: 'Rohstoffe und Bergbau', color: '#9faa5e' },
        { id: 'schutz_recht_festlegung', name: 'Schutzrechtfestlegung ', color: '#87cac4' },
        { id: 'siedlungs_und_nutzung', name: 'Siedlungsnutzung', color: '#edb19e' },
      ]
    },
    { id: 'gebaude', name: 'Gebäude', color: '#FEFEFE', hasChildren: false },
    { id: 'topographie', name: 'Topographie', color: '#c9d9cb', hasChildren: false },
    { id: 'riskGebiet', name: 'Risikogebiete', color: '#9edcf5', hasChildren: false },
    { id: 'bauleitplane', name: 'Bauleitpläne', color: '#c4afa6', hasChildren: false },
    
  ];

  const toggleExpanded = (layerId) => {
    setExpandedSections(prev => ({
      ...prev,
      [layerId]: !prev[layerId]
    }));
  };

  const toggleVisibility = (layerId, e) => {
    e.stopPropagation();
    toggleLayer(layerId);
  };

  return (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '0.5rem',
      padding: '1rem',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      maxWidth: '320px',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '1rem' }}>
        <h3 style={{
          margin: 0,
          fontSize: '0.875rem',
          fontWeight: '600',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: '#374151'
        }}>
          LAYER
        </h3>
      </div>

      {/* Layer List */}
      {!collapsed && (
        <div>
          {layerData.map((layer) => (
            <div key={layer.id} style={{ marginBottom: '0.25rem', margin:0, marginLeft:"-1.75rem" }}>
              <div
                onClick={() => layer.hasChildren && toggleExpanded(layer.id)}
                // onMouseEnter={(e) => {
                //   const button = e.currentTarget.querySelector('.visibility-button');
                //   if (button) button.style.opacity = 1;
                // }}
                // onMouseLeave={(e) => {
                //   const button = e.currentTarget.querySelector('.visibility-button');
                //   if (button) button.style.opacity = 1;
                // }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0.3rem',
                  cursor: layer.hasChildren ? 'pointer' : 'default',
                  fontWeight: '400',
                  fontSize: '13px',
                  color: '#27292B',
                  transition: 'background-color 0.15s ease-in-out',
                  borderRadius: '0.25rem',
                  backgroundColor: 'transparent',
                 
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#F9FAFB'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                {layer.hasChildren && (
                  <span style={{ marginRight: '0.5rem', display: 'flex', alignItems: 'center' }}>
                    {expandedSections[layer.id] ? (
                      <ChevronDown size={16} color="#6B7280" />
                    ) : (
                      <ChevronRight size={16} color="#6B7280" />
                    )}
                  </span>
                )}

                <div style={{
                  width: '0.75rem',
                  height: '0.75rem',
                  borderRadius: '9999px',
                  backgroundColor: layer.color,
                  border: '1px solid lightgrey',
                  marginRight: '0.75rem',
                  marginLeft: !layer.hasChildren ? '1.5rem' : '0',
                  flexShrink: 0
                }} />

                <span style={{
                  fontSize: '0.875rem',
                  color: visibleLayers[layer.id] ? '#374151' : '#9CA3AF',
                  flexGrow: 1
                }}>
                  {layer.name}
                </span>

                <button
                  className="visibility-button"
                  onClick={(e) => toggleVisibility(layer.id, e)}
                  style={{
                    opacity: 1,
                    transition: 'opacity 0.2s ease-in-out',
                    padding: '0.25rem',
                    borderRadius: '0.25rem',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    outline: 'none',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {visibleLayers[layer.id] ? (
                    <Eye size={16} color="#4B5563" />
                  ) : (
                    <EyeOff size={16} color="#9CA3AF" />
                  )}
                </button>
              </div>

              {layer.hasChildren && expandedSections[layer.id] && layer.subLayers && (
                <div style={{
                  backgroundColor: '#FAFAFA',
                  borderRadius: '0.25rem',
                  marginLeft: '2.5rem',
                  marginTop: '0.25rem',
                  marginBottom: '0.5rem',
                  paddingTop: '0.25rem',
                  paddingBottom: '0.25rem'
                }}>
                  {layer.subLayers.map((subLayer) => (
                    <div
                      key={subLayer.id}
                      onMouseEnter={(e) => {
                        const button = e.currentTarget.querySelector('.visibility-button');
                        if (button) button.style.opacity = 1;
                      }}
                      onMouseLeave={(e) => {
                        const button = e.currentTarget.querySelector('.visibility-button');
                        if (button) button.style.opacity = 1;
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0.5rem',
                        fontSize: '13px',
                        color: '#27292B',
                        transition: 'background-color 0.15s ease-in-out',
                        borderRadius: '0.25rem',
                        opacity: 1
                      }}
                      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#F3F4F6'}
                      onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <div style={{
                        width: '0.625rem',
                        height: '0.625rem',
                        borderRadius: '9999px',
                        backgroundColor: subLayer.color,
                        border: '1px solid lightgrey',
                        marginRight: '0.75rem',
                        marginLeft: '0.5rem',
                        flexShrink: 0
                      }} />

                      <span style={{
                        fontSize: '0.8125rem',
                        color: visibleLayers[subLayer.id] ? '#374151' : '#9CA3AF',
                        flexGrow: 1
                      }}>
                        {subLayer.name}
                      </span>

                      <button
                        className="visibility-button"
                        onClick={(e) => toggleVisibility(subLayer.id, e)}
                        style={{
                          opacity: 1,
                          transition: 'opacity 0.2s ease-in-out',
                          padding: '0.25rem',
                          borderRadius: '0.25rem',
                          backgroundColor: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          outline: 'none',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        {visibleLayers[subLayer.id] ? (
                          <Eye size={14} color="#4B5563" />
                        ) : (
                          <EyeOff size={14} color="#9CA3AF" />
                        )}
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LayerControl;